import { NUXT_API_AUTH_ADMIN } from '~/modules/auth/constants'
import type { AuthAdmin } from '~/modules/auth/entities/AuthAdmin'

export default defineNuxtRouteMiddleware(async to => {
  // skip middleware on client side entirely
  if (import.meta.client) return

  const isAdminRoute = to.matched.some(
    matchedRoute => matchedRoute.meta.AuthAdmin === true,
  )
  if (!isAdminRoute) {
    return
  }

  const { $v2ApiNuxtEndpointPlugin } = useNuxtApp()

  const params = {
    id: to.params.id,
  }

  const data = await $v2ApiNuxtEndpointPlugin(NUXT_API_AUTH_ADMIN, params)

  const authAdmin: AuthAdmin = data

  if (authAdmin.logged === false) {
    return navigateTo(routes().login())
  } else if (authAdmin.logged === true && authAdmin.allowed === false) {
    throw showError({
      statusCode: 403,
      statusMessage: 'User not allowed to see page',
    })
  } else if (authAdmin.logged === true && authAdmin.allowed === true) {
    return
  }
  throw showError({
    statusCode: 404,
    statusMessage: 'Something went wrong with your use Auth Admin permissions',
  })
})
